/*
 * Copyright (c) 2019 Hawaii Information Consortium
 * 201 Merchant St #1805, Honolulu, HI 96813
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of Hawaii Information Consortium. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with HIC.
 */

/**
 * History object.
 *
 * @author Natalia, AIS.PL
 */
export class History {

  readonly action: string;

  readonly actionDate: Date;

  readonly actionRequesterName: string;

  readonly id: number;

  /**
   * Converts JSON representation of amendment into {@link Amendment} instance.
   *
   * @param jsonObject JSON representation of purchase report
   */
  static fromJSON(jsonObject: any): History {
    const result = Object.create(History.prototype);
    return Object.assign(result, jsonObject, {
      actionDate: jsonObject.actionDate ? new Date(jsonObject.actionDate) : null
    });
  }

}
